import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/Card.css'
import DataMonitor from './DataMonitor';
//config
import config from '../config';

//Image
import exportData from '../assets/img/Card__exportData.svg'
import exportData__dark from '../assets/img/Card__exportData--dark.svg'

//Material UI Component
import FileCopy from '@material-ui/icons/FileCopy'
import Delete from '@material-ui/icons/Delete'
import Add from '@material-ui/icons/Add'
import Clear from '@material-ui/icons/Clear'
import ImportExport from '@material-ui/icons/ImportExport'
import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

//store
import events from '../store/events';
import profile from '../store/profile';
import errors from '../store/errors';
import prompt from '../store/prompt';
import dialog from '../store/dialog';
import { observer } from 'mobx-react';
import ui from '../store/ui';
//plugin
import axios from 'axios';

// 正则只输入数字、英文字符、-、_
const reg = "^[a-zA-Z0-9-_' ']{0,20}$"

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 200
  },
  formControl: {
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    background: '#fff',
  }
});

@observer
class Card extends React.Component {
  copyEventUrl = this.copyEventUrl.bind(this);
  copyEventAPIKey = this.copyEventAPIKey.bind(this);
  extend = this.extend.bind(this);
  exportEventData = this.exportEventData.bind(this);
  getUrl = this.getUrl.bind(this);
  removeEvent = this.removeEvent.bind(this);
  shrink = this.shrink.bind(this);
  addProperties = this.addProperties.bind(this);
  handleClose = this.handleClose.bind(this);
  handleTypeChange = this.handleTypeChange.bind(this);
  createProperties = this.createProperties.bind(this);
  addMore = this.addMore.bind(this);
  state = {
    errorType: [{'errorType':''}],
    eventName: '',
    open: false,
    requireInputError: [{"requireInputError":false}],
    type: '',
    extend: false,
    number: 0,
    list: [{"property0":1}],
    propertList: []
  }
  addProperties() {
    this.setState({
      open: true
    })
  }
  handleClose() {
    this.setState({
      open: false
    })
    this.clearState();
  }
  addMore() {
    var list = this.state.list;
    var requireInputError = this.state.requireInputError;
    requireInputError.push({"requireInputError":false});
    var errorType = this.state.errorType;
    errorType.push({'errorType':''});
    var number = this.state.number + 1;
    var data = {};
    data[`property${number}`] = 1;
    list.push(data);
    this.setState({
      errorType: errorType,
      requireInputError:requireInputError,
      number: number,
      list: list
    })
  }
  clearState() {
    this.setState({
      type: '',
      eventName: '',
      requireInputError: [{"requireInputError":false}],
      errorType: [{'errorType':''}],
      number: 0,
      list: [{"property0":1}]
    })
  }
  createProperties() {
    const regus = new RegExp(reg)
    var requireInputError = this.state.requireInputError;
    var errorType = this.state.errorType;
    var isCan = true;
    var list = [];
    for(var i = 0;i < this.state.list.length;i++){
      requireInputError[i].requireInputError = false;
      errorType[i].errorType = '';
      this.setState({
        requireInputError: requireInputError,
        errorType: errorType
      })
      if (!regus.test(document.getElementById("property" + i).value)) {
        window.alert('請輸入不超過20个數字、英文、下劃線或橫崗的字符')
        return;
      }
      //validate input
      if (document.getElementById("property" + i).value == '') {
        //prompt Error message
        requireInputError[i].requireInputError = true;
        errorType[i].errorType = errors.type.empty;
        this.setState({
          requireInputError: requireInputError,
          errorType: errorType,
        })
        isCan = false;
        break;
      } else if (list.includes(document.getElementById("property" + i).value)) {
        requireInputError[i].requireInputError = true;
        errorType[i].errorType = errors.type.duplicate;
        this.setState({
          requireInputError: requireInputError,
          errorType: errorType,
        })
        isCan = false;
        break;
      } else if (document.getElementById("property" + i).value.length > 20) {
        requireInputError[i].requireInputError = true;
        errorType[i].errorType = errors.type.maxLength(20);
        this.setState({
          requireInputError: requireInputError,
          errorType: errorType,
        })
        isCan = false;
        break;
      }
      list.push(document.getElementById("property" + i).value);
    }
    if(isCan){
      prompt.message('屬性創建中,請稍等...');
      var value = this.getEventAPIKey();
      var data = {};
      for(var i = 0;i < this.state.list.length;i++){
        data[`${document.getElementById("property" + i).value}`] = "1";
      }
      //Create event on database
      axios.post(`${config.env.server}/iot/data/eventAPIKey/${value}`, data)
        .then(response => response.data === 'EVENT UPDATE' && response.status === 200
          ? prompt.message('創建屬性成功.')
          : prompt.message('創建屬性失敗.請稍後嘗試.'))
        .catch((error) => {
          if (error.response.status === 429) {
            prompt.message('創建屬性失敗.無法創建更多的屬性.')
          }
        })
      //Clear eventname and type state
      this.clearState();
      //Close dialog
      this.handleClose();
    }
  }
  handleTypeChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim()
    })
    events.newEvent.type = event.target.value;
  }
  handleEventNameChange = name => event => {

    this.setState({
      [name]: event.target.value,
      requireInputError: false
    });
    events.newEvent.name = event.target.value;
  }
  fetchData(eventName) {
    events.fetchData(eventName);
  }
  rsyncData() {
    this.fetchData(this.props.name);
    this.interval = setInterval(() => (this.fetchData(this.props.name)), 3000);
  }
  extend(event) {
    if (event.target.className === 'Card' || event.target.className === 'Card__name') {
      this.rsyncData();

      let arr = document.querySelectorAll('.Card')
      for (let i = 0; i < arr.length; i++) {
        if (i === this.props.id) {
          document.querySelectorAll('.Card')[this.props.id].classList.toggle('Card--extend');
        } else {
          document.querySelectorAll('.Card')[i].classList.remove('Card--extend');
        }
      }
      window.location.hash = `Card__eventId--${this.props.name}`
      this.props.clickCard(this.props.id, 'open')
    }
  }
  exportEventData() {
    return window.location.href = `${config.env.server}/iot/data/eventAPIKey/${this.props.eventAPIKey}/export`;
  }
  shrink(event) {
    clearInterval(this.interval);
    document.querySelectorAll('.Card')[this.props.id].classList.toggle('Card--extend');
    this.props.clickCard(this.props.id, 'close')
  }
  removeEvent() {
    // dialog.message('Delete event?','Deleted event may not be recovered.');
    // if(dialog.result){
    //   clearInterval(this.interval);
    //   events.removeEvent(this.props.name);
    // }
    if (window.confirm('刪除事件後將不可恢復，確定要刪除嗎？')) {
      clearInterval(this.interval);
      events.removeEvent(this.props.name);
    }
  }
  copyEventUrl(event) {
    event.stopPropagation();
    events.copyEventUrl(this.props.name);
    prompt.message('複製 URL');
  }
  copyEventAPIKey(event) {
    event.stopPropagation();
    events.copyEventAPIKey(this.props.name);
    prompt.message('複製 API');
  }
  getUrl() {
    var targetUrl = events.generateUrl(this.props.name);
    return targetUrl;
  }
  getEventAPIKey() {
    var targetEventAPIKey = events.getAPIKey(this.props.name);
    return targetEventAPIKey;
  }
  render() {
    const { data, classes } = this.props;
    let number = this.state.number;
    return (
      <div className="Card" onClick={this.extend}>
        <div className="Card__name" id={`Card__eventId--${this.props.name}`}>
          {this.props.name}
        </div>
        <div className="Card__copyEventAPIKey" onClick={this.copyEventAPIKey}>
          {this.props.extend
            ? (
              <Button
                variant='contained'
                color='default'
                size='small'
                style={{ ...styles.button }}
              >
                <FileCopy /><span style={{ marginLeft: 5 }}>複製API鑰匙</span>
              </Button>
            )
            : (
              <Tooltip title='複製 API'>
                <FileCopy />
              </Tooltip>
            )
          }
        </div>
        <div className="Card__copyUrl" onClick={this.copyEventUrl}>
          {this.props.extend
            ? (
              <Button
                variant='contained'
                color='default'
                size='small'
                style={{ ...styles.button }}
              >
                <FileCopy /><span style={{ marginLeft: 5 }}>複製外部鏈接</span>
              </Button>
            )
            : null
          }
        </div>
        {/*<div className="Card__type">
          <span style={{fontSize:12,marginRight:5,alignSelf:'center',width:60,textAlign:'left'}}>Type</span>
          <select name="type" id="Card__typeSelect" className='Card__typeSelect' value={this.props.type} readOnly='true' >
            <option value="trigger">Trigger</option>
            <option value="action">Action</option>
          </select>
        </div>*/}
        <div className="Card__delete" onClick={this.removeEvent}>
          {this.props.extend
            ? (
              <Button
                variant="contained"
                size='small'
                fullWidth
                style={{ ...styles.button }}
              >
                <Delete /><span style={{ marginLeft: 5 }}>刪除事件</span>
              </Button>
            )
            : (
              <Tooltip title='刪除事件'>
                <Delete />
              </Tooltip>
            )
          }
        </div>
        <div className="Card__export" onClick={this.exportEventData}>
          {this.props.extend
            ? (
              <Button
                variant="contained"
                size='small'
                fullWidth
                style={{ ...styles.button }}
              >
                <img src={exportData__dark} alt='exportData' width='24px' height='24px' /><span style={{ marginLeft: 5 }}>導出數據</span>
              </Button>
            )
            : (
              <Tooltip title='導出事件數據'>
                <img src={exportData} alt='exportData' width='24px' height='24px' />
              </Tooltip>
            )
          }
        </div>
        <div className="Card_create_properties" onClick={this.addProperties}>
          {this.props.extend
            ? (
              <Button
                variant="contained"
                size='small'
                fullWidth
                style={{ ...styles.button }}
              >
                <Add /><span style={{ marginLeft: 5 }}>創建屬性</span>
              </Button>
            )
            : (
              <Tooltip title='創建屬性'>
                <Add />
              </Tooltip>
            )
          }
        </div>
        {/*<div className='Card__create'>
          <span style={{fontSize:12,marginRight:5,alignSelf:'center',width:60,textAlign:'left'}}>Create</span>
          <div></div>
        </div>*/}
        <div className='Card__modify'>
          <span style={{ fontSize: 12, marginRight: 5, alignSelf: 'center', width: 75, textAlign: 'left' }}>最後修改</span>
          <div className='Card__modify--content'>{typeof data !== 'undefined' ? new Date(data.meta.timestamp * 1000).toLocaleString() : null}</div>
        </div>
        <div className='Card__property'>
          <span style={{ fontSize: 12, marginRight: 5, alignSelf: 'center', width: 60, textAlign: 'left' }}>屬性</span>
          <ul style={{ padding: 0, margin: 0, listStyleType: 'none', textAlign: 'left', alignSelf: 'center' }}>
            {typeof data !== 'undefined' ? Object.keys(data).map((x, y) => (x == 'meta' ? '' : <li key={x + y}>{x}</li>)) : null}
          </ul>
        </div>
        <div className='Card__apikey'>
          <span style={{ fontSize: 12, marginRight: 5, alignSelf: 'center', width: 60, textAlign: 'left' }}>API 鑰匙</span>
          <textarea
            className='Card__apikey--textarea'
            readOnly
            style={{
              backgroundColor: 'rgba(255,255,255,0.1)',
              color: '#fff',
              border: 0,
              padding: 5,
              resize: 'none',
              borderRadius: '10px',
              height: 40
            }}
            value={this.getEventAPIKey()}>
          </textarea>
        </div>
        <div className='Card__url'>
          <span style={{ fontSize: 12, marginRight: 5, alignSelf: 'center', width: 60, textAlign: 'left' }}>外部請求鏈接</span>
          <textarea
            className='Card__url--textarea'
            readOnly
            style={{
              backgroundColor: 'rgba(255,255,255,0.1)',
              color: '#fff',
              border: 0,
              padding: 5,
              resize: 'none',
              borderRadius: '10px',
              height: 80
            }}
            value={this.getUrl()}>
          </textarea>
        </div>
        <div className='Card__data' style={{ position: 'relative' }}>
          {typeof data !== 'undefined'
            ? Object.keys(data).map((x, y) => (
              x == 'meta'
                ? ''
                : data[x].constructor === Object
                  ? <DataMonitor key={x + y} width='250' height='250' property={x} value='*Error' error={true} />
                  : <DataMonitor key={x + y} width={ui.CardSize()} height={ui.CardSize()} property={x} value={data[x]} />
            ))
            : <div style={{ position: 'absolute', top: 0, width: '90%', height: '100%', background: 'rgba(92,155,228,1)' }}>
              <div className="card_donut"></div>
            </div>
          }

          {typeof data !== 'undefined' ? <DataMonitor width={ui.CardSize()} height={ui.CardSize()} property='id' value={data.meta.id} /> : ''}
          {/*{typeof data !== 'undefined'?  <DataMonitor width={ui.CardSize()} height={ui.CardSize()} property='Last modify' value={new Date(data.meta.timestamp*1000).toLocaleString()}/>:''}*/}

        </div>
        <div className="Card__close" onClick={this.shrink}>
          <Clear />
        </div>
        <div className="AddProperties">
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">創建屬性</DialogTitle>
            <DialogContent >
              <DialogContentText id="alert-dialog-description">請爲屬性命名</DialogContentText>
              <div className={classes.root}>
                <FormControl className={classes.formControl} required >
                {this.state.list.map((x, y) =>
                  <TextField
                    label="屬性名"
                    // value={this.state.eventName}
                    // onChange={this.handleEventNameChange('eventName')}
                    margin="normal"
                    required
                    error={this.state.requireInputError[y].requireInputError}
                    helperText={this.state.requireInputError[y].requireInputError ? this.state.errorType[y].errorType : false}
                    id = {'property' + y}
                    key={x + y}
                  />
                )}
                </FormControl>
                {/*<FormControl className={classes.formControl} >
                <InputLabel htmlFor="type">類型</InputLabel>
                <Select
                  value={this.state.type}
                  onChange={this.handleTypeChange}
                  inputProps={{
                    name: 'type',
                    id:'type'
                  }}
                  >
                  <MenuItem value='trigger'>Trigger</MenuItem>
                  <MenuItem value='action'>Action</MenuItem>
                </Select>
              </FormControl>*/}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.addMore} color="primary">
                添加更多
              </Button>
              <Button onClick={this.handleClose} color="primary">
                取消
            </Button>
              <Button onClick={this.createProperties} color="primary" autoFocus>
                創建
            </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    )
  }
}
Card.propTypes = {
  name: PropTypes.string,
}
export default withStyles(styles)(Card);



// WEBPACK FOOTER //
// ./src/components/Card.js